<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import ApplicationState from "../../../../Stores/applicationStates"
  import notify from "../../../../Script/notify"
  import QRCode from "qrcode"
  import ShareComponent from "../../../../Shared/shareComponent.svelte"
  import { copyToClipboard } from "../../../Publish/SinglePublish/script"
  import { deleteRequest } from "../../../../Script/apiMethods"

  export let json

  /**
   * @type {Boolean} whether to show the delete model are not
   */
  let deleteModel = false
  /**
   * @type {Boolean} whether to show the loader are not
   */
  let apiCallBtnDisable = false
  /**
   * @type {Boolean} whether to show the show more detail model are not
   */
  let showMore = false

  /**
   * @type {Object} this stores the seleted show more list data
   */
  let selectedJson = {}

  /**
   * @type {String} this stores arc value for showing qrcode value
   */
  let qrImage

  /**
   * @type {copiedInfo}
   */
  let copiedInfo = {
    close() {},
  }

  /**
   * @type {aliasNotify}
   */
  let aliasNotify = {
    close() {},
  }

  /**
   * @description Function to show more detail for clicking respective list
   */
  const showMoreDetails = async (json) => {
    try {
      qrImage = await QRCode.toDataURL(json.url)
    } catch (error) {
      const info = "PAGE: Secure Access (URL List)\nEVENT: While generating QRCode for Secure Access (ALIAS) for showing more details"
      notify.danger(error, info)
    }
    selectedJson = json
    showMore = !showMore
  }

  /**
   * @description Function for delete url or list
   */
  const deleteUrl = async () => {
    aliasNotify.close()
    try {
      apiCallBtnDisable = true

      // Fetching document template by ID
      await deleteRequest(`/api/swagger/v2/links/${json.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })
      aliasNotify = notify.success("URL Successfully deleted")
      dispatch("delete", json.id)
    } catch (error) {
      const info = "PAGE: Secure Access (URL List)\nEVENT: While deleting Secure Access (ALIAS) URL List"
      aliasNotify = notify.danger(error, info)
    } finally {
      deleteModel = false
      apiCallBtnDisable = false
    }
  }
</script>

<div class="flex w-full items-center justify-between gap-3 rounded-md bg-[#f7f7f7] p-3 hover:shadow-md dark:border-2 dark:border-transparent dark:bg-bodyblack dark:hover:border-blue-500">
  <div class="flex flex-col gap-2 truncate">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <a target="_blank" href={json.url} title={json.url} class="cursor-pointer truncate text-blue-500 underline hover:text-blue-600 active:text-blue-400">
      {json.url}
    </a>
    <p class="select-none truncate font-medium capitalize text-gray-200">{new Date(json.created).toString().slice(0, 24)}</p>
  </div>
  <div class="flex select-none justify-end">
    <a data-tooltip="Send Email" tooltip-position="top" target="_blank" href="#/analytics/documents/send-email?id={json.documentID}&aliasId={json.id}" class="flex h-9 cursor-pointer items-center justify-center rounded-full px-3 text-sm font-medium text-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-400 disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent md:px-5">
      <i class="fa-solid fa-envelope" />
      <span class="hidden lg:block">&nbsp;&nbsp;Send&nbsp;Email</span>
    </a>
    <button data-tooltip="Show more" tooltip-position="top" on:click={() => showMoreDetails(json)} class="flex h-9 cursor-pointer items-center justify-center rounded-full px-3 text-sm font-medium text-yellow-500 hover:bg-yellow-500 hover:text-white active:bg-yellow-400 disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent md:px-5">
      <i class="fa-solid fa-circle-info" />
      <span class="hidden lg:block">&nbsp;&nbsp;Show&nbsp;more</span>
    </button>
    <button
      on:click={async () => {
        copiedInfo.close()
        await copyToClipboard(json.url)
        copiedInfo = notify.info("URL copied to clipboard")
      }}
      data-tooltip="Copy"
      tooltip-position="top"
      class="flex h-9 cursor-pointer items-center justify-center rounded-full px-3 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white active:bg-sky-400 disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent md:px-5"
    >
      <i class="fa-solid fa-copy" />
      <span class="hidden lg:block">&nbsp;&nbsp;Copy</span>
    </button>

    <button data-tooltip="Delete" tooltip-position="top" on:click={() => (deleteModel = true)} class="flex h-9 cursor-pointer items-center justify-center rounded-full px-3 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white active:bg-red-400 disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent md:px-5">
      <i class="fa-solid fa-trash-can" />
      <span class="hidden lg:block">&nbsp;&nbsp;Delete</span>
    </button>
  </div>
</div>

<div>
  {#if showMore}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div on:click|self={() => (showMore = false)} class="fixed inset-0 -top-3 z-50 flex flex-col items-center justify-center bg-[#000000cc] p-6 backdrop-blur-md">
      <div class="h-auto w-full rounded-md bg-white p-3 dark:bg-bodyblack mobile:p-6 md:w-4/5 xl:w-3/5">
        <div class="mb-6 flex select-none flex-col gap-3 dark:text-white sm:flex-row sm:items-center">
          <strong>Secured by</strong>
          <div class="flex items-center gap-1 mobile:gap-3">
            <button type="button" class="flex {selectedJson.emailList.length >= 1 || selectedJson.emailDomain ? 'bg-blue-500' : ' bg-gray-100/50'} cursor-pointer items-center justify-center gap-1.5 rounded-full px-3 py-1 text-xs text-white focus-visible:text-white focus-visible:outline-none md:px-3 lg:py-1.5 xl:gap-3 xl:px-6">
              <i class="fa-solid fa-envelope hidden sm:block" />
              Email
            </button>
            <button type="button" class="flex {selectedJson.passcode ? 'bg-blue-500' : ' bg-gray-100/50'} cursor-pointer items-center justify-center gap-1.5 rounded-full px-3 py-1 text-xs text-white focus-visible:text-white focus-visible:outline-none md:px-3 lg:py-1.5 xl:gap-3 xl:px-6">
              <i class="fa-solid fa-key hidden sm:block" />
              Passcode
            </button>
            <button type="button" class="flex {selectedJson.nda || selectedJson.notice ? 'bg-blue-500' : ' bg-gray-100/50'} cursor-pointer items-center justify-center gap-1.5 rounded-full px-3 py-1 text-xs text-white focus-visible:text-white focus-visible:outline-none md:px-3 lg:py-1.5 xl:gap-3 xl:px-6">
              <i class="fa-solid fa-link hidden sm:block" />
              URL
            </button>
            <button type="button" class="flex {selectedJson.expireOn ? 'bg-blue-500' : ' bg-gray-100/50'} cursor-pointer items-center justify-center gap-1.5 rounded-full px-3 py-1 text-xs text-white focus-visible:text-white focus-visible:outline-none md:px-3 lg:py-1.5 xl:gap-3 xl:px-6">
              <i class="fa-solid fa-calendar-days hidden sm:block" />
              Date
            </button>
          </div>
        </div>
        <div class="flex flex-col items-center justify-between gap-6 sm:flex-row">
          <!-- link -->
          <div class="order-2 flex w-full flex-col items-center gap-3 sm:order-1 sm:items-start md:w-4/6">
            <div>
              <a class="flex break-all text-center text-blue-500 underline hover:text-blue-600 active:text-blue-400 sm:text-start" target="_blank" href={selectedJson.url}>{selectedJson.url}</a>
              <p class="select-none text-center text-gray-200 sm:text-start">Click URL to open in new tab</p>
            </div>
            <!-- share -->
            <ShareComponent Link={selectedJson.url} />
          </div>

          <!-- qrcode -->
          <div class="order-1 flex w-full select-none flex-col items-center gap-3 sm:order-2 md:w-2/6">
            <img src={qrImage} class="w-1/3 rounded-md sm:w-4/6" alt="qrcode" />
          </div>
        </div>
        <!-- valitity -->
        <div class="mt-3 select-none items-center gap-6 sm:flex">
          <div class="flex items-center gap-3">
            <i class="fa-solid fa-calendar-lines-pen text-green-600" />
            <!-- <p class="font-semibold">Created on</p> -->
            <p class="font-medium capitalize text-green-500">{new Date(selectedJson.created).toDateString()}</p>
          </div>
          {#if selectedJson.expireOn}
            <div class="flex items-center gap-3">
              <i class="fa-solid fa-calendar-xmark text-red-600" />
              <!-- <p class="font-semibold">Expire on</p> -->
              <p class="font-medium capitalize text-red-500">{new Date(selectedJson.expireOn).toDateString()}</p>
            </div>
            <div class="flex items-center gap-3">
              <i class="fa-solid fa-calendar-exclamation text-yellow-600" />
              <!-- <p class="font-semibold">Expire on</p> -->
              <p class="font-medium text-yellow-500">
                Expiry within <strong>{Math.round((new Date(selectedJson.expireOn) - Date.now()) / (1000 * 60 * 60 * 24)) + 1}</strong>
                days
              </p>
            </div>
          {/if}
        </div>
      </div>
      <div class="mb-6 mt-3 flex select-none items-center justify-center text-lg font-semibold text-white mobile:text-xl">To close, click outside</div>
    </div>
  {/if}

  {#if deleteModel}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="fixed inset-0 z-50 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
      <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
        <div class="flex w-full items-center justify-center rounded-md bg-white p-3 text-black dark:bg-bodyblack md:p-6">
          <h1 class="select-none text-center text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Delete Alias URL</h1>
        </div>

        <div class="break-words p-3 text-center text-gray-400 md:p-6">
          Do you want to&nbsp; <strong>Delete</strong>
          &nbsp;this
          <strong>&nbsp;Alias&nbsp;</strong>
          URL ?
        </div>

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-2 dark:bg-bodyblack sm:flex md:gap-0 md:p-4">
          <button on:click={() => (deleteModel = false)} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-blue-500 hover:text-white focus:outline-none disabled:cursor-not-allowed dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto">
            <span>
              <i class="fa-solid fa-circle-xmark" />
            </span>
            <span class="select-none">&nbsp;No</span>
          </button>
          <button on:click={deleteUrl} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none disabled:cursor-not-allowed dark:bg-lightgray dark:text-white dark:hover:bg-green-500 sm:ml-3 sm:w-auto">
            <span>
              <i class="fa-solid fa-circle-check" />
            </span>
            <span class="select-none">&nbsp;Yes</span>
          </button>
        </div>
      </div>
    </div>
  {/if}
</div>

<!-- </div> -->

<style>
  /* .shadow {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  } */
</style>
